import React from "react";
import { BaseModal } from "../base";
import PDFViewer from "./PDFViewer";
import { UploadedResultPdf } from "../../store/slices/order/types";

const ViewResultModal = ({
    isResultOpen,
    closeModal,
    record
}: {
    isResultOpen: boolean;
    closeModal: any;
    record: UploadedResultPdf;
}) => {
    return (
        <BaseModal
            closeModal={closeModal}
            closable={false}
            visible={isResultOpen}
            modalSize="extra-large"
        >
            <div>
                <div className="flex items-center justify-end py-4 mr-7 mb-10">
                    <div
                        className="py-1 px-3 bg-gray-200 cursor-pointer rounded-md text-gray-900"
                        onClick={closeModal}
                    >
                        Close Result
                    </div>
                </div>
                {record?.url !== "" ? (
                    <PDFViewer imageUrl={record?.url} />
                ) : (
                    <div>
                        <div className="flex items-center border border-gray-300 justify-center h-full">
                            <div className="bg-red-600 rounded-md px-4 py-3 text-white">
                                Cannot load the document
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </BaseModal>
    );
};

export default ViewResultModal;
